"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BorderStyle = exports.BorderColor = exports.Border = exports.NoBorder = void 0;
var NoBorder;
(function (NoBorder) {
    NoBorder["All"] = "u-border-none";
})(NoBorder = exports.NoBorder || (exports.NoBorder = {}));
var Border;
(function (Border) {
    Border["All"] = "u-border";
    Border["AllX2"] = "u-border-x2";
    Border["Top"] = "u-border-top";
    Border["Right"] = "u-border-right";
    Border["Bottom"] = "u-border-bottom";
    Border["Left"] = "u-border-left";
})(Border = exports.Border || (exports.Border = {}));
var BorderColor;
(function (BorderColor) {
    BorderColor["CurrentColor"] = "u-border-color-cc";
    BorderColor["Color1"] = "u-border-color-1";
    BorderColor["Color2"] = "u-border-color-2";
    BorderColor["Color3"] = "u-border-color-3";
    BorderColor["Positive"] = "u-border-color-pos";
    BorderColor["Negative"] = "u-border-color-neg";
    BorderColor["Warning"] = "u-border-color-warn";
})(BorderColor = exports.BorderColor || (exports.BorderColor = {}));
var BorderStyle;
(function (BorderStyle) {
    BorderStyle["Solid"] = "u-border-style-solid";
    BorderStyle["Dashed"] = "u-border-style-dashed";
    BorderStyle["Dotted"] = "u-border-style-dotted";
    BorderStyle["Double"] = "u-border-style-double";
})(BorderStyle = exports.BorderStyle || (exports.BorderStyle = {}));
//# sourceMappingURL=Border.js.map